import React from 'react'

import { Dialog, DialogContent } from '@material-ui/core'

import { useFilterList } from '../FilterContext'

export const FilterModal: React.FC = ({ children }) => {
  const { openFilterModal, onCloseFilterModal } = useFilterList()

  return (
    <Dialog onClose={onCloseFilterModal} open={openFilterModal}>
      <DialogContent>{children}</DialogContent>
    </Dialog>
  )
}
